import './illinoisstateuniversity/style';
import FormStructure from './illinoisstateuniversity/form_structure';

export default FormStructure;